var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoardWithChecksIconBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2222 2.27778H10.5031C10.136 1.244 9.15911 0.5 8 0.5C6.84089 0.5 5.864 1.244 5.49689 2.27778H1.77778C0.795556 2.27778 0 3.07333 0 4.05556V16.5C0 17.4822 0.795556 18.2778 1.77778 18.2778H14.2222C15.2044 18.2778 16 17.4822 16 16.5V4.05556C16 3.07333 15.2044 2.27778 14.2222 2.27778ZM7.11111 13.8333H3.55556V12.0556H7.11111V13.8333ZM7.11111 9.38889H3.55556V7.61111H7.11111V9.38889ZM8 4.05556C7.50933 4.05556 7.11111 3.65733 7.11111 3.16667C7.11111 2.676 7.50933 2.27778 8 2.27778C8.49067 2.27778 8.88889 2.676 8.88889 3.16667C8.88889 3.65733 8.49067 4.05556 8 4.05556ZM11.0347 13.8333H8.88889V12.0556H10.2987L12.0764 10.2778L13.3333 11.5347L11.0347 13.8333ZM11.0347 9.38889H8.88889V7.61111H10.2987L12.0764 5.83333L13.3333 7.09022L11.0347 9.38889ZM14.2222 16.5H1.77778V4.05556H14.2222V16.5Z",
    fill: "#131314"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoardWithChecksIconBlack);
export default __webpack_public_path__ + "static/media/board-with-checks-icon-black.c59769cb0732411718272022e61c9913.svg";
export { ForwardRef as ReactComponent };